import styled from 'styled-components';

export const FooterLink = styled.a<{ themeColor: types.theme.themeColors }>`
	display: block;
	text-decoration: none;
	${({ theme, themeColor }) => ({ color: theme.colors[themeColor || 'white'] })}
	${({ theme }) => theme.typography.paragraphS}
`;
